import React from 'react';
import { FormattedMessage } from 'translations';
import { Layout, Flex } from 'app/components/base/Layout';

import style from './style.css';

const messages = {
  title: { id: 'BOOK_TRIP.CONTACT_INFO.PASSWORD_HINT_HEADER' },
  text: { id: 'BOOK_TRIP.CONTACT_INFO.PASSWORD_HINT' }
};

const MobilePasswordCaption = () => (
  <Layout className={style.container}>
    <Flex>
      <div className={style.title}>
        <FormattedMessage {...messages.title} />
      </div>
      <FormattedMessage {...messages.text} />
    </Flex>
  </Layout>
);

export default MobilePasswordCaption;
